var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHiddeneyes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8374_70687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.15625 3.38627C8.70917 3.20121 10.28 3.52948 11.6288 4.32097C12.9777 5.11246 14.0304 6.32366 14.6263 7.76961C14.6818 7.91928 14.6818 8.08393 14.6263 8.23361C14.3812 8.8276 14.0575 9.38594 13.6636 9.89361",
    stroke: "#6A7282",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38942 9.43737C9.01222 9.80169 8.50702 10.0033 7.98262 9.99872C7.45823 9.99417 6.9566 9.78383 6.58579 9.41301C6.21497 9.0422 6.00463 8.54057 6.00008 8.01618C5.99552 7.49178 6.19711 6.98658 6.56142 6.60938",
    stroke: "#6A7282",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6517 11.6704C10.7674 12.1943 9.78068 12.5218 8.75861 12.6307C7.73654 12.7396 6.703 12.6274 5.72812 12.3017C4.75324 11.976 3.85983 11.4443 3.10851 10.7429C2.35719 10.0415 1.76554 9.18665 1.3737 8.23642C1.31814 8.08674 1.31814 7.92209 1.3737 7.77242C1.96479 6.33899 3.00482 5.13591 4.3377 4.34375",
    stroke: "#6A7282",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33398 1.33594L14.6673 14.6693",
    stroke: "#6A7282",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8374_70687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiddeneyes);
export default __webpack_public_path__ + "static/media/hiddeneyes.12cd9d2f61359e72abc0de45db54cf15.svg";
export { ForwardRef as ReactComponent };